import { useDockBinding, type DockBinding } from "./askDockStore.js";
import type { YagniRailScope } from "./yagniRailScopes.js";

/**
 * Binds the Ask dock to a scope while it is mounted, for a surface that
 * renders it beside its center (so the binding can sit after early returns).
 */
export function DockScope({ scope, ...rest }: { scope: YagniRailScope } & Omit<DockBinding, "scope">) {
  useDockBinding({ scope, ...rest });
  return null;
}
